import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function PaymentWall({ onPaymentComplete, onBack }) {
  // We trigger the transition immediately when they click the pay link
  // This removes the "I've Paid" button friction entirely
  const handlePayClick = () => {
    // Small delay ensures the browser has time to trigger the external link 
    // before the React state change potentially unmounts the component
    setTimeout(() => {
      onPaymentComplete();
    }, 1500);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 1.05 }}
      className="w-full max-w-lg mx-auto"
    >
      <div className="glass-panel rounded-[2.5rem] overflow-hidden relative border-emerald-500/30">
        {/* Header Decoration */}
        <div className="h-24 bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 flex items-center justify-center border-b border-slate-800">
          <div className="flex -space-x-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="w-12 h-12 rounded-full bg-slate-900 border-2 border-slate-800 flex items-center justify-center text-xl shadow-lg">
                {i === 1 ? '👔' : i === 2 ? '📈' : '✨'}
              </div>
            ))}
          </div>
        </div>

        <div className="p-8 md:p-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-xs font-bold uppercase tracking-wider mb-4 border border-emerald-500/20">
            <SafeIcon icon="Lock" className="w-3 h-3" />
            Locked: Serious Mode
          </div>
          
          <h2 className="text-3xl font-extrabold text-white mb-2">Ready to get hired?</h2>
          <p className="text-slate-400 mb-8">
            Unlock the professional rewrite, ATS optimization score, and exact formatting fixes.
          </p>

          <div className="bg-slate-950/50 rounded-3xl p-8 mb-8 border border-slate-800 relative group">
            <div className="absolute inset-0 bg-emerald-500/5 rounded-3xl blur-xl group-hover:bg-emerald-500/10 transition-colors" />
            
            <div className="relative z-10">
              <div className="text-sm text-slate-500 font-semibold uppercase tracking-widest mb-1">One-time payment</div>
              <div className="text-6xl font-black text-white mb-8 tracking-tight">$2.99</div>
              
              <a 
                href="https://cash.app/$MutationLabs" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={handlePayClick}
                className="flex items-center justify-center gap-3 bg-[#00D632] hover:bg-[#00c22d] text-white font-bold py-5 px-6 rounded-2xl transition-all transform hover:scale-[1.02] active:scale-95 shadow-[0_0_30px_rgba(0,214,50,0.3)] mb-4 w-full"
              >
                <SafeIcon icon="DollarSign" className="text-2xl" />
                Pay with Cash App
              </a>
              
              <div className="flex items-center justify-center gap-4 mt-6">
                <div className="flex items-center gap-1.5 text-[10px] text-slate-500 font-bold uppercase tracking-tighter">
                  <SafeIcon icon="ShieldCheck" className="w-3 h-3 text-emerald-500" />
                  Secure
                </div>
                <div className="w-1 h-1 rounded-full bg-slate-800" />
                <div className="flex items-center gap-1.5 text-[10px] text-slate-500 font-bold uppercase tracking-tighter">
                  <SafeIcon icon="Zap" className="w-3 h-3 text-emerald-500" />
                  Instant Reveal
                </div>
              </div>
            </div>
          </div>

          <button 
            onClick={onBack}
            className="text-slate-500 hover:text-slate-300 text-sm font-medium transition-colors flex items-center justify-center gap-2 mx-auto"
          >
            <SafeIcon icon="ArrowLeft" className="w-3 h-3" />
            Back to roast
          </button>
        </div>
      </div>
    </motion.div>
  );
}